import React, { useState, useEffect } from 'react';
import { getMySubjects, createQuiz, getMyQuizzes, updateQuiz, getQuizResults } from '../../api';
import { toast } from 'react-toastify';

const Quizzes = () => {
  const [subjects, setSubjects] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingQuiz, setEditingQuiz] = useState(null);
  const [quizResults, setQuizResults] = useState([]);
  const [selectedQuizId, setSelectedQuizId] = useState(null);
  const [loadingResults, setLoadingResults] = useState(false);

  const [form, setForm] = useState({
    title: '', subject_id: '', duration_minutes: 30, is_active: true, questions: []
  });

  useEffect(() => {
    loadSubjects();
    loadQuizzes();
  }, []);

  const loadSubjects = async () => {
    try {
      const res = await getMySubjects();
      setSubjects(res.data);
    } catch {
      toast.error('Error loading subjects');
    }
  };

  const loadQuizzes = async () => {
    try {
      const res = await getMyQuizzes();
      setQuizzes(res.data);
    } catch {
      toast.error('Error loading quizzes');
    }
  };

  const viewResults = async (quizId) => {
    if (selectedQuizId === quizId) {
      setSelectedQuizId(null);
      setQuizResults([]);
      return;
    }
    setLoadingResults(true);
    setSelectedQuizId(quizId);
    try {
      const res = await getQuizResults(quizId);
      setQuizResults(res.data);
    } catch {
      toast.error('Results load nahi hue');
    }
    setLoadingResults(false);
  };

  const addQuestion = () => {
    setForm(prev => ({
      ...prev,
      questions: [...prev.questions, {
        question: '', option_a: '', option_b: '', option_c: '', option_d: '',
        correct_answer: 'a', marks: 1
      }]
    }));
  };

  const updateQuestion = (index, field, value) => {
    const updated = [...form.questions];
    updated[index][field] = value;
    setForm(prev => ({ ...prev, questions: updated }));
  };

  const removeQuestion = (index) => {
    setForm(prev => ({
      ...prev,
      questions: prev.questions.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async () => {
    if (!form.title || !form.subject_id) return toast.error('Title aur subject zaroori hain!');
    if (form.questions.length === 0) return toast.error('Kam az kam ek question add karo!');
    try {
      if (editingQuiz) {
        await updateQuiz(editingQuiz.id, form);
        toast.success('Quiz updated!');
      } else {
        await createQuiz(form);
        toast.success('Quiz created!');
      }
      setShowForm(false);
      setEditingQuiz(null);
      setForm({ title: '', subject_id: '', duration_minutes: 30, is_active: true, questions: [] });
      loadQuizzes();
    } catch {
      toast.error('Error saving quiz');
    }
  };

  const startEdit = (quiz) => {
    setEditingQuiz(quiz);
    setForm({
      title: quiz.title,
      subject_id: quiz.subject_id,
      duration_minutes: quiz.duration_minutes,
      is_active: quiz.is_active,
      questions: quiz.questions || []
    });
    setShowForm(true);
  };

  return (
    <div>
      <div style={styles.header}>
        <h3 style={styles.title}>📋 My Quizzes</h3>
        <button style={styles.addBtn} onClick={() => { setShowForm(true); setEditingQuiz(null); }}>
          + Create Quiz
        </button>
      </div>

      {showForm && (
        <div style={styles.formCard}>
          <h4 style={styles.formTitle}>{editingQuiz ? 'Edit Quiz' : 'New Quiz'}</h4>

          <input style={styles.input} placeholder="Quiz Title" value={form.title}
            onChange={e => setForm({ ...form, title: e.target.value })} />

          <select style={styles.input} value={form.subject_id}
            onChange={e => setForm({ ...form, subject_id: e.target.value })}>
            <option value="">Select Subject</option>
            {subjects.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>

          <input style={styles.input} type="number" placeholder="Duration (minutes)"
            value={form.duration_minutes}
            onChange={e => setForm({ ...form, duration_minutes: e.target.value })} />

          <label style={styles.checkLabel}>
            <input type="checkbox" checked={form.is_active}
              onChange={e => setForm({ ...form, is_active: e.target.checked })} />
            &nbsp; Active (students ko dikhe ga)
          </label>

          <h4 style={styles.formTitle}>Questions</h4>
          {form.questions.map((q, i) => (
            <div key={i} style={styles.questionBox}>
              <div style={styles.qHeader}>
                <span style={styles.qNum}>Q{i + 1}</span>
                <button style={styles.removeBtn} onClick={() => removeQuestion(i)}>✕</button>
              </div>
              <input style={styles.input} placeholder="Question" value={q.question}
                onChange={e => updateQuestion(i, 'question', e.target.value)} />
              {['a', 'b', 'c', 'd'].map(opt => (
                <input key={opt} style={styles.input}
                  placeholder={`Option ${opt.toUpperCase()}`}
                  value={q[`option_${opt}`]}
                  onChange={e => updateQuestion(i, `option_${opt}`, e.target.value)} />
              ))}
              <select style={styles.input} value={q.correct_answer}
                onChange={e => updateQuestion(i, 'correct_answer', e.target.value)}>
                {['a', 'b', 'c', 'd'].map(opt => (
                  <option key={opt} value={opt}>Correct: {opt.toUpperCase()}</option>
                ))}
              </select>
              <input style={styles.input} type="number" placeholder="Marks" value={q.marks}
                onChange={e => updateQuestion(i, 'marks', e.target.value)} />
            </div>
          ))}

          <button style={styles.addQBtn} onClick={addQuestion}>+ Add Question</button>

          <div style={styles.formActions}>
            <button style={styles.cancelBtn} onClick={() => { setShowForm(false); setEditingQuiz(null); }}>
              Cancel
            </button>
            <button style={styles.saveBtn} onClick={handleSubmit}>
              {editingQuiz ? 'Update Quiz' : 'Save Quiz'}
            </button>
          </div>
        </div>
      )}

      {quizzes.length === 0 && !showForm && (
        <div style={styles.empty}>Koi quiz nahi bani abhi!</div>
      )}

      {quizzes.map(q => (
        <div key={q.id} style={styles.quizCard}>
          <div style={styles.quizInfo}>
            <h4 style={styles.quizTitle}>{q.title}</h4>
            <p style={styles.quizMeta}>📚 {q.subject_name} &nbsp;|&nbsp; ⏱️ {q.duration_minutes} min &nbsp;|&nbsp;
              <span style={{ color: q.is_active ? '#28a745' : '#dc3545' }}>
                {q.is_active ? '✅ Active' : '❌ Inactive'}
              </span>
            </p>
          </div>
          <div style={styles.quizActions}>
            <button style={styles.editBtn} onClick={() => startEdit(q)}>Edit</button>
            <button style={styles.resultBtn} onClick={() => viewResults(q.id)}>
              {selectedQuizId === q.id ? 'Hide Results' : 'Results Dekho'}
            </button>
          </div>

          {selectedQuizId === q.id && (
            <div style={styles.resultsBox}>
              {loadingResults ? (
                <p style={styles.loadingText}>Loading...</p>
              ) : quizResults.length === 0 ? (
                <p style={styles.noResults}>Kisi ne abhi attempt nahi kiya</p>
              ) : (
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Student</th>
                      <th style={styles.th}>Marks</th>
                      <th style={styles.th}>Total</th>
                      <th style={styles.th}>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {quizResults.map((r, i) => (
                      <tr key={i} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={styles.td}>{r.student_name}</td>
                        <td style={styles.td}>{r.obtained_marks}</td>
                        <td style={styles.td}>{r.total_marks}</td>
                        <td style={styles.td}>{new Date(r.submitted_at).toLocaleDateString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#1a3a5c', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#0d6efd', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a3a5c', margin: '0 0 15px' },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginBottom: '10px', boxSizing: 'border-box' },
  checkLabel: { fontSize: '14px', color: '#444', display: 'block', marginBottom: '15px' },
  questionBox: { background: '#f8f9fa', borderRadius: '8px', padding: '15px', marginBottom: '15px' },
  qHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
  qNum: { fontWeight: 'bold', color: '#1a3a5c' },
  removeBtn: { background: '#dc3545', color: 'white', border: 'none', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer' },
  addQBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', marginBottom: '15px' },
  formActions: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  cancelBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  saveBtn: { padding: '10px 20px', background: '#28a745', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  quizCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  quizInfo: { marginBottom: '10px' },
  quizTitle: { color: '#1a3a5c', margin: '0 0 5px', fontSize: '16px' },
  quizMeta: { color: '#666', fontSize: '13px', margin: 0 },
  quizActions: { display: 'flex', gap: '10px' },
  editBtn: { padding: '8px 16px', background: '#ffc107', color: '#333', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  resultBtn: { padding: '8px 16px', background: '#0d6efd', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  resultsBox: { marginTop: '15px', borderTop: '1px solid #eee', paddingTop: '15px' },
  loadingText: { color: '#666', fontSize: '14px' },
  noResults: { color: '#999', fontSize: '14px' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: { background: '#f0f4ff', color: '#1a3a5c', padding: '10px', textAlign: 'left', fontWeight: '600' },
  td: { padding: '10px', color: '#444' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
};

export default Quizzes;